import { Outlet } from "react-router-dom";

/** Grid routes render full-screen scorecards — no app chrome. */
export function GridLayout() {
  return <Outlet />;
}
